import React from 'react'
import raw from 'raw.macro'
import Markdown from '../../atoms/Markdown'

// 登録画面用
export const CompMathMethodExperimentalDesignHelpText = () => (
  <Markdown>{raw('../../../markdowns/helpText/CompMathMethodExperimentalDesign.md')}</Markdown>
)

export const UnitOfAnalysisHelpText = () => <Markdown>{raw('../../../markdowns/helpText/UnitOfAnalysis.md')}</Markdown>

export const Dsm5HelpText = () => <Markdown>{raw('../../../markdowns/helpText/Dsm5.md')}</Markdown>

export const SymptomatologyHelpText = () => <Markdown>{raw('../../../markdowns/helpText/Symptomatology.md')}</Markdown>

export const RdocConstructsHelpText = () => <Markdown>{raw('../../../markdowns/helpText/RdocConstructs.md')}</Markdown>

// 検索画面用
export const NeuroscienceHelpText = () => <Markdown>{raw('../../../markdowns/helpText/Neuroscience.md')}</Markdown>

export const PsychiatryHelpText = () => <Markdown>{raw('../../../markdowns/helpText/Psychiatry.md')}</Markdown>

export const ComputationHelpText = () => <Markdown>{raw('../../../markdowns/helpText/Computation.md')}</Markdown>
